import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "color", "display", "fontSize", "lineHeight", "fontWeight", "letterSpacing", "ellipsis", "rowEllipsis", "textIndent", "textAlign", "textShadow", "userSelect", "verticalAlign", "whiteSpace", "wordWrap", "textDecoration", "textTransform", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* LIBRARIES */
import * as React from 'react';
import { clsx } from 'clsx';
/* STYLES */
import styles from '../styles/common.module.css';
import displayStyles from '../../../../internal/styles/display.module.css';
import typographyStyles from '../../../../typography/sizes.module.css';
import userSelectStyles from '../../../../internal/styles/userSelect.module.css';
/* TYPES */

import colorsStyles from '@cian/ui-kit-design-tokens/colors/colors.module.css';
import deprecatedColorsStyles from '@cian/ui-kit-design-tokens/colors/deprecated/colors.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Компонент `Text`. Предназначен для отображения любого текста.
 * <br/>
 * Имеет различные настройки отображения типографики.
 * <br/>
 * Самостоятельное использование текста заприщено.
 */
const TextComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      as = 'span',
      color = 'text-primary-default',
      display = 'inline-block',
      fontSize = '16px',
      lineHeight = '22px',
      fontWeight = 'normal',
      letterSpacing = 0,
      ellipsis,
      rowEllipsis,
      textIndent,
      textAlign,
      textShadow,
      userSelect,
      verticalAlign,
      whiteSpace,
      wordWrap,
      textDecoration,
      textTransform,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const TagName = as;
  const letterSpacingClassName = styles["text_letterSpacing__".concat(letterSpacing)];
  return /*#__PURE__*/_jsx(TagName, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    style: {
      letterSpacing: letterSpacingClassName ? null : letterSpacing,
      textShadow,
      textIndent
    },
    className: clsx(deprecatedColorsStyles["color_".concat(color)], colorsStyles["color_".concat(color)], typographyStyles["lineHeight_".concat(lineHeight)], typographyStyles["fontWeight_".concat(fontWeight)], typographyStyles["fontSize_".concat(fontSize)], displayStyles["display_".concat(display)], styles['text'], styles["fontWeight__".concat(fontWeight)], letterSpacingClassName, {
      [userSelectStyles["userSelect_".concat(userSelect)]]: userSelect,
      [styles["text_textDecoration__".concat(textDecoration)]]: textDecoration,
      [styles["text_textTransform__".concat(textTransform)]]: textTransform,
      [styles["text_rowEllipsis__".concat(rowEllipsis)]]: rowEllipsis,
      [styles['text_rowEllipsis']]: rowEllipsis,
      [styles['text_ellipsis']]: ellipsis,
      [styles["text_textAlign__".concat(textAlign)]]: textAlign,
      [styles["text_verticalAlign__".concat(verticalAlign)]]: verticalAlign,
      [styles["text_whiteSpace__".concat(whiteSpace)]]: whiteSpace,
      [styles["text_wordWrap__".concat(wordWrap)]]: wordWrap
    }),
    children: children
  }));
});
TextComponent.displayName = 'Text';
export const Text = /*#__PURE__*/React.memo(TextComponent);